import React from 'react';
import PropTypes from 'prop-types';
import { CCard, CCardBody, CFormSwitch } from '@coreui/react';

const AlertTypes = ({ config, updateConfig }) => (
  <CCard className="shadow-sm border-0 bg-white h-100">
    <CCardBody className="p-3">
      <div className="mb-3">
        <h6 className="fw-bold text-dark mb-1">
          Моментальные алерты (Инциденты)
        </h6>
        <p className="text-muted small mb-0">
          Выберите события, при которых нужно мгновенно отправлять сообщение (например, в Telegram).
        </p>
      </div>
      <div className="d-flex flex-column gap-3">
        <CFormSwitch
          id="alert_battery"
          label={<span className="fw-semibold">Критический заряд батареи</span>}
          checked={config.alert_battery}
          onChange={(e) => updateConfig({ alert_battery: e.target.checked })}
        />
        <CFormSwitch
          id="alert_power_off"
          label={<span className="fw-semibold">Внезапное отключение питания</span>}
          checked={config.alert_power_off}
          onChange={(e) => updateConfig({ alert_power_off: e.target.checked })}
        />
        <CFormSwitch
          id="alert_temp"
          label={<span className="fw-semibold">Перегрев оборудования</span>}
          checked={config.alert_temp}
          onChange={(e) => updateConfig({ alert_temp: e.target.checked })}
        />
        <CFormSwitch
          id="alert_idle_truck"
          label={<span className="fw-semibold">Простой самосвала под стрелой</span>}
          checked={config.alert_idle_truck}
          onChange={(e) => updateConfig({ alert_idle_truck: e.target.checked })}
        />
        <div className="border-top pt-2 mt-1">
          <div className="text-muted small fw-bold mb-2">Технические системные алерты:</div>
          <CFormSwitch
            id="alert_static"
            label="Зависание видеопотока"
            checked={config.alert_static}
            onChange={(e) => updateConfig({ alert_static: e.target.checked })}
          />
          <CFormSwitch
            id="alert_dark"
            label="Камера закрыта / Нет света"
            checked={config.alert_dark}
            onChange={(e) => updateConfig({ alert_dark: e.target.checked })}
          />
          <CFormSwitch
            id="alert_ai_frozen"
            label="Сбой работы нейросетей"
            checked={config.alert_ai_frozen}
            onChange={(e) => updateConfig({ alert_ai_frozen: e.target.checked })}
          />
        </div>
      </div>
    </CCardBody>
  </CCard>
);

AlertTypes.propTypes = {
  config: PropTypes.object.isRequired,
  updateConfig: PropTypes.func.isRequired,
};

export default AlertTypes;